import { defineComponent, ref } from 'vue';
import RegionTableComponent from '@/components/regionTable/RegionTable.vue';
import RegionFormComponent from '@/components/regionTable/regionForm/RegionForm.vue';

export default defineComponent({
  name: 'RegionPage',
  components: {
    RegionTableComponent,
    RegionFormComponent
  },
  setup: () => {
    const regionId = ref<number | null>(null);
    const regionForm = ref<InstanceType<typeof RegionFormComponent>>();

    const createClick = () => {
      Promise.resolve(regionId.value = null)
        .then(() => regionForm.value?.show());
    };

    const editClick = (id: number) => {
      Promise.resolve(regionId.value = id)
        .then(() => regionForm.value?.show());
    };

    return {
      regionForm,
      regionId,
      createClick,
      editClick
    };
  },
});
